import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarEdit"><Path d="M9 2H7V4H3V21H12V19H5V10H19V11H21V4H17V2H15V4H9V2Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 12.5858L14 18.5858V22H17.4142L23.4142 16L20 12.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarEdit;
